import { Ctx } from "@budibase/types"
import { users as usersCore } from "@budibase/backend-core"
import { users } from "../../../sdk"

export async function addAppBuilder(ctx: Ctx) {
  const { userId, appId } = ctx.params
  const user = await users.db.getUser(userId)
  if (usersCore.isGlobalBuilder(user)) {
    ctx.body = { message: "User already admin - no permissions updated." }
    return
  }
  await users.addAppBuilder(user, appId)
  ctx.body = { message: `User "${user.email}" app builder access updated.` }
}

export async function removeAppBuilder(ctx: Ctx) {
  const { userId, appId } = ctx.params
  const user = await users.db.getUser(userId)
  if (usersCore.isGlobalBuilder(user)) {
    ctx.body = { message: "User already admin - no permissions removed." }
    return
  }
  await users.removeAppBuilder(user, appId)
  ctx.body = { message: `User "${user.email}" app builder access removed.` }
}
